module.exports = __webpack_public_path__ + "img/spiral.e1793886.jpg";